import { BaseBlockProps } from '../../defs/block';

export type SharpenerBlockID =
  | 'sharpenerLeft'
  | 'sharpenerRight'
  | 'sharpenerTop'
  | 'sharpenerBottom';

export type SharpenerBlockType = 'sharpener';

export type SharpenerBlockProps = {
  type: 'sharpener';
} & BaseBlockProps;

export const sharpenerBlockProps: Record<
  SharpenerBlockID,
  SharpenerBlockProps
> = {
  sharpenerLeft: {
    id: 'shl',
    type: 'sharpener',
    immobile: true,
    orientation: 'leftToRight',
    options: [
      { count: 0, width: 1 },
      { count: 1, width: 2 },
      { count: 2, width: 3 },
      { count: 3, width: 4 },
      { count: 4, width: 5 },
      { count: 5, width: 6 },
      { count: 6, width: 7 },
      { count: 7, width: 8 },
      { count: 8, width: 9 },
    ],
    optionType: 'list',
  },
  sharpenerRight: {
    id: 'shr',
    type: 'sharpener',
    immobile: true,
    orientation: 'rightToLeft',
    options: [
      { count: 0, width: 1 },
      { count: 1, width: 2 },
      { count: 2, width: 3 },
      { count: 3, width: 4 },
      { count: 4, width: 5 },
      { count: 5, width: 6 },
      { count: 6, width: 7 },
      { count: 7, width: 8 },
      { count: 8, width: 9 },
    ],
    optionType: 'list',
    sharedGoal: 'sharpenerLeft',
  },
  sharpenerTop: {
    id: 'shtop',
    type: 'sharpener',
    immobile: true,
    orientation: 'topToBottom',
    options: [
      { count: 0, height: 1 },
      { count: 1, height: 2 },
      { count: 2, height: 3 },
      { count: 3, height: 4 },
      { count: 4, height: 5 },
      { count: 5, height: 6 },
      { count: 6, height: 7 },
      { count: 7, height: 8 },
      { count: 8, height: 9 },
    ],
    optionType: 'list',
    sharedGoal: 'sharpenerLeft',
  },
  sharpenerBottom: {
    id: 'shbot',
    type: 'sharpener',
    immobile: true,
    orientation: 'bottomToTop',
    options: [
      { count: 0, height: 1 },
      { count: 1, height: 2 },
      { count: 2, height: 3 },
      { count: 3, height: 4 },
      { count: 4, height: 5 },
      { count: 5, height: 6 },
      { count: 6, height: 7 },
      { count: 7, height: 8 },
      { count: 8, height: 9 },
    ],
    optionType: 'list',
    sharedGoal: 'sharpenerLeft',
  },
};
